import { ROVVideoStatus } from 'src/enums'
import { IROVVideoMinimal } from 'src/generated-types/rovvideo'

export type RovVideoContentVariant = 'transcoding' | 'thumbnail' | 'blob-placeholder' | 'vimeo-iframe'

type RovVideoStatusInput = Pick<
  IROVVideoMinimal,
  'azureBlobURL' | 'azureThumbnailURL' | 'thumbnail_URL' | 'vimeoId' | 'status'
>

export const shouldFetchVimeoOEmbed = (
  rovvideo: Pick<RovVideoStatusInput, 'azureBlobURL' | 'azureThumbnailURL' | 'thumbnail_URL' | 'vimeoId'>,
): boolean => !rovvideo.azureBlobURL && !rovvideo.azureThumbnailURL && !rovvideo.thumbnail_URL && !!rovvideo.vimeoId

export const getRovVideoContentVariant = (
  rovvideo: Pick<RovVideoStatusInput, 'azureBlobURL' | 'status'>,
  thumbnailUrl: string | undefined,
): RovVideoContentVariant => {
  if (rovvideo.status === ROVVideoStatus.Transcoding) return 'transcoding'
  if (thumbnailUrl) return 'thumbnail'
  if (rovvideo.azureBlobURL) return 'blob-placeholder'
  return 'vimeo-iframe'
}
